import { Button, Modal } from "@salesapp/ui";

export function CloseTicketModal({
  open,
  comment,
  notifyUser,
  canNotify,
  onCommentChange,
  onNotifyChange,
  onCancel,
  onConfirm,
  saving = false,
}: {
  open: boolean;
  comment: string;
  notifyUser: boolean;
  canNotify: boolean;
  onCommentChange: (value: string) => void;
  onNotifyChange: (value: boolean) => void;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
  saving?: boolean;
}) {
  return (
    <Modal
      isOpen={open}
      onClose={onCancel}
      title="Close this ticket"
      footer={
        <>
          <Button variant="secondary" onClick={onCancel}>Cancel</Button>
          <Button onClick={onConfirm} disabled={!comment.trim() || saving}>
            {saving ? "Closing…" : "Close ticket"}
          </Button>
        </>
      }
    >
      <p className="crm-help">A resolution comment is required. It is stored as an update on the ticket.</p>
      <div className="crm-resizable-field">
        <label className="crm-field" htmlFor="close-ticket-comment">Resolution</label>
        <div className="crm-resizable-field-shell">
          <textarea
            id="close-ticket-comment"
            value={comment}
            onChange={(event) => onCommentChange(event.target.value)}
            placeholder="What resolved this issue?"
            required
          />
        </div>
      </div>
      <label className="crm-check">
        <input
          type="checkbox"
          checked={notifyUser}
          disabled={!canNotify}
          onChange={(event) => onNotifyChange(event.target.checked)}
        />
        Notify the contact by email
      </label>
      {!canNotify ? (
        <p className="crm-muted">This contact has no email address to notify.</p>
      ) : null}
    </Modal>
  );
}
